import { app } from "@/plugins/appAxios";

// 获取微信配置
export function bindWechat(params) {
  return app("/general/bind/wechat/", params);
}
export function update_wx_anonymous_info(params) {
  return app("/generate/update_wx_anonymous_info", params);
}
